<template>
  <div class="official-coach-bond">
    <div class="off-event-box">
      <img :src="bgImg.seq1">
      <img :src="bgImg.seq2">
      <img :src="bgImg.seq3">
      <img :src="bgImg.seq4">
      <img :src="bgImg.seq5">
      <img :src="bgImg.seq6">
      <img :src="bgImg.seq7">
      <img :src="bgImg.seq8">
      <img :src="bgImg.seq9">
    </div>
    <div class="off-footer-box display-flex-end">
      <div v-if="false" class="off-btn-item blue"><div>联系顾问</div></div>
      <div class="off-btn-item pop" @click="goTrial"><div>我想试用</div></div>
    </div>
  </div>
</template>

<script>
import { getAppPath, varConfig, ImageFormat } from '@/utils'

export default {
  name: 'officialCoachBond',
  data() {
    return {
      bgImg: {}
    }
  },
  created() {

  },
  mounted() {
    this.shareData = {
      title: '邦教练・十分钟就能上手的体育培训管理系统',
      abstract: '更优惠 更简单 更聚焦',
      link: this.getShareLink(),
      image: ImageFormat.squareImageView('Fmq6_Gt_3iCom1S2zCUMrN5lphGc', 120)
    }
    this.wxShare(this.shareData)
    const bgImg = {}
    bgImg.seq1 = ImageFormat.squareImageView('FkOxBkfHrRu3KZZsR6gE_Jsxz4TO', 0)
    bgImg.seq2 = ImageFormat.squareImageView('FuGstmRqBDwXTyJHsgfg42h8dXDV', 0)
    bgImg.seq3 = ImageFormat.squareImageView('Fj3daF2mCVLwJ6LjAMSy_7XUCOJp', 0)
    bgImg.seq4 = ImageFormat.squareImageView('FtxA5d2Flsrj0pe5Ki1ewZAeXSsk', 0)
    bgImg.seq5 = ImageFormat.squareImageView('Fto-_NIDmf5mWOpx8MakssmPgtQW', 0)
    bgImg.seq6 = ImageFormat.squareImageView('FhlcQ3tapEL29uafLRtlcTo7am0N', 0)
    bgImg.seq7 = ImageFormat.squareImageView('FgwJjkrb36PV5wq848hI810C2-6b', 0)
    bgImg.seq8 = ImageFormat.squareImageView('FqCfYINhh1sw2MiNJ6Fg64MInjwT', 0)
    bgImg.seq9 = ImageFormat.squareImageView('FoVd8mMjeuQ7ImDVCqvYR3QMmhm9', 0)

    this.bgImg = bgImg
  },
  methods: {
    goTrial() {
      const path = getAppPath('webapplt')
      const url = `${varConfig.siteUrl}/${path}/index/index.html#/reservation?type=3&result=青训管理`
      window.location.href = url
    },
    getShareLink: function () {
      const arr = window.location.href.split('index.html')
      return arr[0] + 'index.html#/official-coachBond?v=1'
    }
  }
}
</script>

<style lang="scss">
  .official-coach-bond {
    .off-event-box{
      width: 100%;
      position: relative;
      padding-bottom: 51px;
      img{
        width: 100%;
        height: 100%;
        position: relative;
        top: 0;
        left: 0;
        display: block;
      }
    }
    .off-footer-box{
      position: fixed;
      bottom: 0;
      width: 100%;
      max-width: 480px;
      height: 50px;
      background: rgba(255, 255, 255, 0.8);
      padding: 4px 0;
      .off-btn-item{
        display: inline-block;
        padding: 4px 17px;
        border-radius: 24px;
        color: #FFFFFF;
        cursor: pointer;
      }
      .blue{
        background: linear-gradient(180deg, #6295E3 0%, #42659B 100%);
        margin-right: 15px;
      }
      .pop{
        background: linear-gradient(180deg, #C465F0 0%, #784FB5 100%);
        margin-right: 38px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/official-coachBond/index.vue